// extracted by mini-css-extract-plugin
export default {"headerBar":"Hospital_headerBar__tyTzY","card":"Hospital_card__0qPcO","cardContainer":"Hospital_cardContainer__0pAmZ","image":"Hospital_image__osPYu"};